import { AnyHandler, SimpleHandler } from './../../types/handlers';
import { CalcInfo, SupplCalcInfo, CalcMethod, SupplCalcMethod } from './../../types/project-config';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { CalcUtil, ConfigAttribute } from 'app/types/project-config';
import { Project } from 'app/model/project';

@Component({
  selector: 'app-calculation-method-selector',
  templateUrl: './calculation-method-selector.component.html',
  styleUrls: ['./calculation-method-selector.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class CalculationMethodSelectorComponent implements OnInit {
  private _ready = false;

  private _attribute?:ConfigAttribute;
  @Input()
  public set attribute(attr:ConfigAttribute | undefined) {
    this._attribute = attr;
    if(!this._attribute) {
      this._selectedMethod = 'static';
    } else {
      this._selectedMethod = this._attribute.calc;
    }
    this.Refresh();
  }
  public get attribute():ConfigAttribute | undefined {
    return this._attribute;
  }

  private _project?:Project;
  @Input()
  public set project(prj:Project|undefined) {
    this._project = prj;
    this.Refresh();
  }
  public get project():Project | undefined{
    return this._project;
  }


  private _target?:'attributes'|'suppl';
  @Input()
  set target(which:'attributes'|'suppl' | '' | undefined) {
    if(!this._ready) {
      this.Defer(()=>{
        this.target = which;
      })
      return;
    }
    if(which === '') which = undefined;
    this._target = which;

    this.Refresh();
  }
  get target():'attributes'|'suppl'| '' |  undefined {
    return this._target;
  }

  public get methods():Array<CalcInfo | SupplCalcInfo> {
    const methodList:Array<CalcInfo> | Array<SupplCalcInfo> = CalcUtil.GetCalc(this._target);
    if(methodList.length === 0) return methodList;
    return (methodList as Array<any>).filter((value:CalcInfo | SupplCalcInfo)=>{
      return this.IsViewableMethod(value);
    });
  }

  private _selectedMethod:CalcMethod | SupplCalcMethod = '';
  public set selectedMethod(method:CalcMethod | SupplCalcMethod | undefined) {
     if(method === undefined) method = '';
    this._selectedMethod = method;
    this.methodSelectedChange.emit(this._selectedMethod);
    this.Refresh();
  }
  public get selectedMethod():CalcMethod | SupplCalcMethod {
    return this._selectedMethod;
  }
  @Output()
  public methodSelectedChange = new EventEmitter<CalcMethod | SupplCalcMethod>();
  constructor(private cdr:ChangeDetectorRef) { }
  ngOnInit(): void {
    this._ready = true;
  }
  public Refresh(force:boolean = false) {
    if(!this._ready) return;
    if(force === true) this.cdr.markForCheck();
    this.cdr.detectChanges();
  }
  IsViewableMethod(calcMethod: CalcInfo | SupplCalcInfo): boolean {
    if (!(this.project && this.attribute)) return false;
    if ((this.target === 'suppl') && (calcMethod.type === 'suppl')) return calcMethod.selectable;
    if (this.target === 'suppl') return false;
    const method: CalcInfo = calcMethod as CalcInfo;
    const id = this.attribute.id;
    const featureType = this.project.GetFeatureType(id);
    if(method.selectable === true) {
      if(method.distance_based === true) {
        if (featureType !== 'segment') return false;
      }
      return true;
    }
    return false;
  }
  Defer(handler:SimpleHandler) {

    window.requestAnimationFrame(()=>{
      handler();
    });
  }
}
